import { useFlagConditionally } from '@mentimeter/flags/confidence/client';
import { LocalStorage } from '@mentimeter/storage';
import { APPLIED_QUICK_ACTION_KEY } from '@mentimeter/onboarding-setup';

interface UseForcefulEditorTourExperimentResult {
  isForcefulEditorTourActive: boolean;
  appliedQuickAction: 'poll' | 'wordcloud' | null;
}

export const useForcefulEditorTourExperiment =
  (): UseForcefulEditorTourExperimentResult => {
    const appliedQuickAction = LocalStorage.getItem(APPLIED_QUICK_ACTION_KEY);
    const shouldResolve =
      appliedQuickAction === 'poll' || appliedQuickAction === 'wordcloud';

    const { isReady, value: showForcefulEditorTour } = useFlagConditionally(
      shouldResolve,
      'nux-forceful-editor-tour.enabled',
      false,
    );

    return {
      isForcefulEditorTourActive: isReady && showForcefulEditorTour,
      appliedQuickAction: appliedQuickAction as 'poll' | 'wordcloud',
    };
  };
